import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route } from 'react-router-dom';
import {
  Application, Tour,
} from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import FwPlugins from 'framework-plugins';
import {
  cambiaUfficio,
  attivaTour730,
  disattivaTour730,
  attivaTourRichiesteEnti,
  disattivaTourRichiesteEnti,
  attivaTourImu,
  disattivaTourImu,
} from 'actions/utenteActions';
import MenuHome from 'Home';
import MenuGeco from 'GeCo';
import Assistente from 'Assistente';
import { MenuUtente } from 'framework-ui-components/Components/V2';
import PrestazioniAgevolate from '../../areas/PrestazioniAgevolate';
import Visureipocatastali from '../../areas/Visureipocatastali';
import Isee from '../../areas/Isee';
import Home from '../../areas/Home';
import HomeSetteTrenta from '../../areas/SetteTrenta';
import SetteTrentaNew from '../../areas/SetteTrentaNew';
import RichiesteEnti from '../../areas/RichiesteEnti';
import Successioni from '../../areas/Successioni';
import ANF from '../../areas/ANF';
import AssegnoUnicoUniversaleMonoanno from '../../areas/AssegnoUnicoUniversaleMonoanno';
import ElaborazioniMassive from '../../areas/ElaborazioniMassive';
import ElaborazioniMassiveNew from '../../areas/ElaborazioniMassiveNew';
import DettaglioOperazione from '../../areas/ElaborazioniMassive/DettaglioOperazione';
import Imu from '../../areas/Imu';
import Firme from '../../areas/Firme';
import ServiziCittadino from '../../areas/ServiziCittadino';
import Disoccupazioni from '../../areas/Disoccupazioni';
import { setValue as setPreferenza } from '../../utils/salvataggioPreferenze';
import { getValue as getGlobalValue, setValue as setGlobalValue } from '../../utils/globalStorage';

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.menuHomePlaceHolderRef = React.createRef();
    this.menuAssistentePlaceHolderRef = React.createRef();
  }

  componentDidMount() {
    this.menuHomePlaceHolderRef.current.addEventListener('click', this.onClickCheck, true);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ufficio.CodiceUfficio != nextProps.ufficio.CodiceUfficio) {
      SnackbarManager.notifySuccess(`Hai selezionato l'ufficio ${nextProps.ufficio.CodiceUfficio}.`);
      this.props.history.push(this.props.history.location.pathname);
    }
  }

  componentWillUnmount() {
    this.menuHomePlaceHolderRef.current.removeEventListener('click', this.onClickCheck, true);
  }

  onClickCheck = (event) => {
    FwPlugins.clickOutEventFilter(event);
  };

  checkFunction = (funct) => {
    FwPlugins.clickOutFunctionFilter(funct);
  };

  cambiaUfficio(x) {
    MenuGeco.cambiaUfficio(x.CodiceUfficio);
    MenuHome.cambiaUfficio(x.CodiceUfficio);
    Assistente.impostaUfficio(x.CodiceUfficio);
    setPreferenza('CodiceUfficio', x.CodiceUfficio);
    this.props.cambiaUfficio(x);
    // invio messaggio ad eventuali iframes
    FwPlugins.postMessageToChilds(FwPlugins.PluginMessageTypes.CHANGE_OFFICE, x.CodiceUfficio);
  }

  vaiAdAssistente() {
    switch (window.datiUtente.ServizioSelezionato) {
      case '7OLRIC':
        window.open(`https://assistente.cgn.it/Permalink/Area/730?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case '7OL':
        window.open(`https://assistente.cgn.it/Permalink/Area/730?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case 'SUC':
        window.open(`https://assistente.cgn.it/Permalink/Area/SUC?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case 'RIC':
        window.open(`https://assistente.cgn.it/Permalink/Area/RIC?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case 'IMU':
        window.open(`https://assistente.cgn.it/Permalink/Area/ICI?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case 'ANF':
        window.open('https://assistente.cgn.it/#/Area/73/Dossier/224');
        break;
      case 'AUU':
        window.open('https://assistente.cgn.it/#/Area/73/Ricerca/AUU/');
        break;
      case 'VIP':
        window.open(`https://assistente.cgn.it/Permalink/Area/VIP?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      case 'DIS':
        window.open(`https://assistente.cgn.it/Permalink/Area/DIS?codiceUfficio=${this.props.ufficio.CodiceUfficio}`);
        break;
      default:
        break;
    }
  }

  areaAssistente() {
    if (window.location.hash.startsWith('#/SetteTrenta')
      || window.location.hash.startsWith('#/NewSetteTrenta')) {
      return '730';
    }

    if (window.location.hash.startsWith('#/successioni')) {
      return 'SUC';
    }

    if (window.location.hash.startsWith('#/richiesteenti')) {
      return 'RIC';
    }

    if (window.location.hash.startsWith('#/imu')) {
      return 'ICI';
    }

    if (window.location.hash.startsWith('#/ANF')) {
      return 'ANF';
    }

    if (window.location.hash.startsWith('#/AssegnoUnicoUniversaleMonoanno')) {
      return 'AUU';
    }

    if (window.location.hash.startsWith('#/firme')) {
      return 'FEA';
    }

    if (window.location.hash.startsWith('#/isee')) {
      return 'ISE';
    }

    if (window.location.hash.startsWith('#/prestazioniagevolate')) {
      return 'ISE';
    }

    if (window.location.hash.startsWith('#/ServiziCittadino')) {
      return 'SCI';
    }

    if (window.location.hash.startsWith('#/visureipocatastali')) {
      return 'VIP';
    }

    if (window.location.hash.startsWith('#/disoccupazioni')) {
      return 'DIS';
    }
  }

  areaQuesiti() {
    if (window.location.hash.startsWith('#/NewSetteTrenta/richieste-enti')) {
      return 'RIC';
    }

    if (window.location.hash.startsWith('#/SetteTrenta')
      || window.location.hash.startsWith('#/NewSetteTrenta')) {
      return '730';
    }

    if (window.location.hash.startsWith('#/successioni')) {
      return 'SUC';
    }

    if (window.location.hash.startsWith('#/richiesteenti')) {
      return 'RIC';
    }

    if (window.location.hash.startsWith('#/imu')) {
      return 'ICI';
    }

    if (window.location.hash.startsWith('#/ANF')) {
      return 'ANF';
    }

    if (window.location.hash.startsWith('#/AssegnoUnicoUniversaleMonoanno')) {
      return 'AUU';
    }

    if (window.location.hash.startsWith('#/firme')) {
      return 'FEA';
    }

    if (window.location.hash.startsWith('#/isee')) {
      return 'ISE';
    }

    if (window.location.hash.startsWith('#/prestazioniagevolate')) {
      return 'ISE';
    }

    if (window.location.hash.startsWith('#/ServiziCittadino')) {
      return 'SCI';
    }

    if (window.location.hash.startsWith('#/visureipocatastali')) {
      return 'VIP';
    }

    if (window.location.hash.startsWith('#/disoccupazioni')) {
      return 'DIS';
    }
  }

  disattivaTour730() {
    setGlobalValue('tour-730-attivo', 'no');
    setGlobalValue('tour-730-attivo-data', new Date().toISOString());
    this.props.disattivaTour730();
  }

  disattivaTourRichiesteEnti() {
    setGlobalValue('tour-richiesteenti-attivo2', 'no');
    this.props.disattivaTourRichiesteEnti();
  }

  disattivaTourImu() {
    setGlobalValue('tour-imu-attivo', 'no');
    this.props.disattivaTourImu();
  }

  aggiungiGiorniAData(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  render() {
    const {
      attivaTour730,
      attivaTourRichiesteEnti,
      attivaTourImu,
      children,
      profilo,
      ufficio,
      location,
      tourRichiesteEntiAttivo,
    } = this.props;

    const areaSettetrentaAttiva = location.pathname.startsWith('/SetteTrenta');
    const tour730Attivo = this.props.tour730Attivo || getGlobalValue('tour-730-attivo') != 'no';
    const tour730AttivoData = getGlobalValue('tour-730-attivo-data');

    const areaRichiesteEntiAttiva = location.pathname.startsWith('/richiesteenti') || location.pathname.startsWith('/SetteTrenta/RichiesteEnti');

    const areaImuAttiva = location.pathname.startsWith('/imu');
    const tourImuAttivo = this.props.tourImuAttivo || getGlobalValue('tour-imu-attivo') != 'no';

    setTimeout(() => MenuGeco.inizializzaMenuPlugin(window.config.urlSupport, this.props.profilo.IdentificativoUtente, this.props.ufficio.CodiceUfficio, document.getElementById('menuGeCoPlaceHolder'), null, 'drawer', this.areaQuesiti()));
    setTimeout(() => MenuHome.inizializza(window.config.urlHome, this.props.profilo.IdentificativoUtente, this.props.ufficio.CodiceUfficio, document.getElementById('menuHomePlaceHolder')));
    setTimeout(() => Assistente.inizializza(window.config.urlAssistente, this.props.profilo.IdentificativoUtente, this.props.ufficio.CodiceUfficio, this.areaAssistente(), document.getElementById('menuAssistentePlaceHolder')));

    return (
      <Application>
        <Application.Header className="dashboard_application_header--brand-identity" logo={<div className="logo-dashboard" />}>
          <span
            id="menuHomePlaceHolder"
            style={{
              position: 'absolute', top: '0', left: '0', cursor: 'pointer',
            }}
            ref={this.menuHomePlaceHolderRef}
          />
          <span
            id="menuAssistentePlaceHolder"
            style={{
              float: 'right',
            }}
            ref={this.menuAssistentePlaceHolderRef}
          />
          <span id="menuGeCoPlaceHolder" />
          <MenuUtente
            utente={{ nome: profilo.Nome, cognome: profilo.Cognome }}
            uffici={profilo.Uffici.map((uff) => uff.CodiceUfficio)}
            ufficioSelezionato={ufficio.CodiceUfficio}
            onUfficioChange={(CodiceUfficio) => {
              const ufficioSelected = profilo.Uffici.find((uff) => uff.CodiceUfficio === CodiceUfficio);
              this.checkFunction(() => this.cambiaUfficio(ufficioSelected));
            }}
            myCgnUrl={window.config.portaleUnicoUrl}
            accountsUrl={window.config.accountsUrl}
            onLogout={(url) => window.location.replace(`${url}?redirectUri=${window.datiUtente.RedirectUri}`)}
          />
        </Application.Header>
        <Application.Body>
          {children}

          {/* Routing */}
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/settetrenta" component={HomeSetteTrenta} />
            <Route path="/NewSetteTrenta/:detail?" component={SetteTrentaNew} />
            <Route path="/richiesteenti/:detail?" component={RichiesteEnti} />
            <Route exact path="/successioni" component={Successioni} />
            <Route exact path="/ANF" component={ANF} />
            <Route path="/AssegnoUnicoUniversaleMonoanno/:detail?" component={AssegnoUnicoUniversaleMonoanno} />
            {window.config.operazioniPluginEnabled === 'true' && <Route path="/elaborazionimassive/:detail?" component={ElaborazioniMassiveNew} />}
            {window.config.operazioniPluginEnabled !== 'true' && <Route exact path="/elaborazionimassive" component={ElaborazioniMassive} />}
            {window.config.operazioniPluginEnabled !== 'true' && <Route exact path="/elaborazionemassiva/:id" component={DettaglioOperazione} />}
            <Route path="/imu/:detail?" component={Imu} />
            <Route path="/firme/:detail?" component={Firme} />
            <Route path="/isee/:detail?" component={Isee} />
            <Route path="/prestazioniagevolate/:detail?" component={PrestazioniAgevolate} />
            <Route path="/ServiziCittadino/:detail?" component={ServiziCittadino} />
            <Route path="/visureipocatastali/:detail?" component={Visureipocatastali} />
            <Route path="/disoccupazioni/:detail?" component={Disoccupazioni} />
          </Switch>

          {tour730Attivo && areaSettetrentaAttiva
            && (
              <Tour
                onEnd={this.disattivaTour730.bind(this)}
                slides={[
                  './Content/images/tour-730/tour-730-01.png',
                  './Content/images/tour-730/tour-730-02.png',
                  './Content/images/tour-730/tour-730-03.png',
                  './Content/images/tour-730/tour-730-04.png',
                  './Content/images/tour-730/tour-730-05.png',
                  './Content/images/tour-730/tour-730-06.png',
                  './Content/images/tour-730/tour-730-07.png',
                  './Content/images/tour-730/tour-730-08.png',
                  './Content/images/tour-730/tour-730-09.png']}
              />
            )}

          {tourRichiesteEntiAttivo && areaRichiesteEntiAttiva
            && (
              <Tour
                onEnd={this.disattivaTourRichiesteEnti.bind(this)}
                slides={[
                  './Content/images/tour-richiesteEnti/1.png',
                  './Content/images/tour-richiesteEnti/2.png',
                  './Content/images/tour-richiesteEnti/3.png',
                  './Content/images/tour-richiesteEnti/4.png',
                  './Content/images/tour-richiesteEnti/5.png',
                  './Content/images/tour-richiesteEnti/6.png',
                  './Content/images/tour-richiesteEnti/7.png',
                  './Content/images/tour-richiesteEnti/8.png']}
              />
            )}

          {false // DISATTIVATO      //tourImuAttivo && areaImuAttiva
            && (
              <Tour
                onEnd={this.disattivaTourImu.bind(this)}
                slides={[
                  './Content/images/tour-imu/1.png',
                  './Content/images/tour-imu/2.png',
                  './Content/images/tour-imu/3.png',
                  './Content/images/tour-imu/4.png',
                  './Content/images/tour-imu/5.png',
                  './Content/images/tour-imu/6.png',
                  './Content/images/tour-imu/7.png']}
              />
            )}
        </Application.Body>
      </Application>
    );
  }
}

const mapStoreToProps = (store) => ({
  profilo: store.utente.profilo,
  ufficio: store.utente.ufficioSelezionato,
  tour730Attivo: store.utente.tour730Attivo,
  tourRichiesteEntiAttivo: store.utente.tourRichiesteEntiAttivo,
  tourImuAttivo: store.utente.tourImuAttivo,
});

const mapDispatchToProps = (dispatch) => ({
  cambiaUfficio: bindActionCreators(cambiaUfficio, dispatch),
  attivaTour730: bindActionCreators(attivaTour730, dispatch),
  disattivaTour730: bindActionCreators(disattivaTour730, dispatch),
  attivaTourRichiesteEnti: bindActionCreators(attivaTourRichiesteEnti, dispatch),
  disattivaTourRichiesteEnti: bindActionCreators(disattivaTourRichiesteEnti, dispatch),
  attivaTourImu: bindActionCreators(attivaTourImu, dispatch),
  disattivaTourImu: bindActionCreators(disattivaTourImu, dispatch),
});

AppContainer.propTypes = {
  cambiaUfficio: PropTypes.func,
  attivaTour730: PropTypes.func,
  disattivaTour730: PropTypes.func,
  disattivaTourRichiesteEnti: PropTypes.func,
  disattivaTourImu: PropTypes.func,
  children: PropTypes.any,
  profilo: PropTypes.object,
  ufficio: PropTypes.object,
};

AppContainer.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStoreToProps, mapDispatchToProps)(AppContainer);
